// extracted by mini-css-extract-plugin
export default {"root":"FieldPhoneNumber_root__6YVYO","inputError":"FieldPhoneNumber_inputError__2qqFW","phoneNumber":"FieldPhoneNumber_phoneNumber__BOhT+"};